// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3eNEU","gfeWrapper":"CalendarEvent_gfeWrapper__2bUkI"};